if (!window.postMsgListeners) window.postMsgListeners = {};
const listeners = window.postMsgListeners;
let inited = false;

export function _emit(key, ...params) {
  if (!listeners[key]) return;
  listeners[key].forEach((item) => item(...params));
}

const messageHandler = function (e) {
  const { data = {}, type } = e;
  if (type !== 'message') return;
  const { data: _data, uniqueKey } = data;
  if (!uniqueKey) return;
  console.log('iframeMsg', data);
  _emit(uniqueKey, _data);
};

export function on(key, fn) {
  if (!listeners[key]) {
    listeners[key] = [];
  }
  listeners[key].push(fn);
}

export function off(key, fn?) {
  const currGroup = listeners[key];
  if (!currGroup) return;
  listeners[key] = (currGroup.map((cFn) => {
    if (!fn || (fn && cFn === fn)) {
      return null;
    }
    return cFn;
  })?.filter(Boolean)) as Function[];
}

export function one(key, fn) {
  off(key);
  listeners[key] = [fn];
}

export function init() {
  if (inited) return;
  window.addEventListener(
    'message',
    messageHandler,
    false,
  );
  inited = true;
}

export function unInit() {
  window.removeEventListener(
    'message',
    messageHandler,
    false,
  );
}

export function sendChild(key, params?, iframeId = 'merchant_mainContentIframe') {
  const iframe = document.getElementById(iframeId);
  if (!iframe) return;
  // @ts-ignore
  iframe.contentWindow.postMessage({ uniqueKey: key, data: params }, '*');
}

export function sendParent(key, params?) {
  const parent = window.parent;
  if (!parent) return;
  parent.postMessage({ uniqueKey: key, data: params }, '*');
}
